import React from 'react';
import './EventPosters.css';

import chair from '../assets/posters/chairbadge.jpg';
import vicechair from '../assets/posters/vicechairbadge.jpg';
import secretary from '../assets/posters/secretarybadge.jpg';
import treasurer from '../assets/posters/treasurerbadge.jpg';
import webmaster from '../assets/posters/webmasterbadge.jpg';
import mchair from '../assets/posters/mchairbadge.jpg';

const posters = [
    chair,
    vicechair,
    secretary,
    treasurer,
    webmaster,
    mchair
];

const EventPosters = () => {
    return (
        <section className="posters-section">
            <h2 className="posters-section-title">
                {/* Events Organized by Our Team */}
                Office Bearers 
            </h2>
            <p className="posters-section-subtitle">
                {/* We build beautiful products with the latest technologies. We are a team of passionate developers and designers that love to build amazing products. */}
                PCE ACM Office Bearers are responsible for leading and managing the activities of the ACM student chapter at PCE.
            </p>
            {/* The main container for the carousel */}
            <div className="posters-carousel-container">
                <div className="posters-carousel-track">
                    {/* Render posters twice for a seamless loop */}
                    {posters.map((poster, index) => (
                        <div className="poster-card" key={`p1-${index}`}>
                            <img src={poster} alt={`Event Poster ${index + 1}`} />
                        </div>
                    ))}
                    {posters.map((poster, index) => (
                        <div className="poster-card" key={`p2-${index}`}>
                            <img src={poster} alt={`Event Poster ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EventPosters;
